import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'DIVORCES_FORM', {
  TITLE: 'Divorce Procedure Form',
  MARRIAGE: 'Marriage',
  HUSBAND: 'Husband',
  WIFE: 'Wife',
  DOCUMENTS: 'Documents',
  COMMENTS: 'Comments',
  MARRIAGE_INFORMATION: 'Marriage information',
  HUSBAND_INFORMATION: 'Husband information',
  WIFE_INFORMATION: 'Wife information',
  DOCUMENTS_INFORMATION: 'Documents information',
  WEDDING_TEMPLE: 'Temple where the parents were married',
  WEDDING_DATE: 'Jupa wedding date',
  FIRST_NAME: 'First names',
  LAST_NAME: 'Last names',
  EMAIL: 'Email',
  ID_CARD_TYPE: 'ID Card type',
  ID_CARD: 'ID card',
  ID_CARD_FILE: 'ID card file',
  ID_CARD_BACK_FILE: 'ID card back file',
  KETUBA_FILE: 'Ketuba file',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate file',
  DIVORCE_CERTIFICATE_FILE: 'Divorce certificate file',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  ADDRESS: 'Address',
  APARTMENT: 'Floor/Apartment',
  LOCALITY: 'locality',
  FILES: 'Files',
  DELETE_DIALOG_TITLE: 'Delete divorce file',
  DELETE_DIALOG_MESSAGE: 'Are you sure you want to delete the file <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
  KETUBA_DIV_DESC: 'Original religious marriage book (Ketuba).',
  MARR_CERT_DESC: 'Civil marriage certificate.',
  ID_BOTH_DESC: 'ID card of both spouses (front and back).',
  DIV_CERT_DESC: 'Civil divorce certificate (if already obtained).',
  SPOUSE_LINEAGE_DOCS: 'Spouse lineage documents',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'DIVORCES_FORM', {
  TITLE: 'Formulario de Divorcio',
  MARRIAGE: 'Matrimonio',
  HUSBAND: 'Esposo',
  WIFE: 'Esposa',
  DOCUMENTS: 'Documentos',
  COMMENTS: 'Observaciones',
  MARRIAGE_INFORMATION: 'Información del matrimonio',
  HUSBAND_INFORMATION: 'Información del esposo',
  WIFE_INFORMATION: 'Información de la esposa',
  DOCUMENTS_INFORMATION: 'Información de los documents',
  WEDDING_TEMPLE: 'Templo donde se casaron (por jupá)',
  WEDDING_DATE: 'Fecha de casamiento',
  FIRST_NAME: 'Nombres',
  LAST_NAME: 'Apellidos',
  EMAIL: 'Email',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento de identidad (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  DIVORCE_CERTIFICATE_FILE: 'Certificado de divorcio',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  ADDRESS: 'Domicilio',
  APARTMENT: 'Piso/Departamento',
  LOCALITY: 'Localidad',
  FILES: 'Archivos',
  DELETE_DIALOG_TITLE: 'Eliminar archivo del divorcio',
  DELETE_DIALOG_MESSAGE: 'Estás seguro de querer eliminar el archivo <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Enviar',
  LOADING: 'Cargando...',
  KETUBA_DIV_DESC: 'Libreta de matrimonio religioso (Ketubá) original.',
  MARR_CERT_DESC: 'Acta o certificado de matrimonio civil.',
  ID_BOTH_DESC: 'DNI de ambos cónyuges (frente y dorso).',
  DIV_CERT_DESC: 'Sentencia de divorcio civil (si ya se posee).',
  SPOUSE_LINEAGE_DOCS: 'Documentos de la línea familiar',
});
